import { render, staticRenderFns } from "./CreateAtlas.vue?vue&type=template&id=0736e3a4&"
import script from "./CreateAtlas.vue?vue&type=script&lang=js&"
export * from "./CreateAtlas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports